import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import NotifyBar from 'syft-acp-atoms/NotifyBar'

import { areShiftOffersStopped, getIsSyftForce } from './helpers'

// Yellow warning shown at the top of the Shift details when offers for the shift are stopped (PTE-51963).
// Visibility is driven by the same `areShiftOffersStopped` condition as the Stop/Resume shift offers button.
export const ListingShiftOffersStoppedAlert = ({ stoppedOffers }) => {
  if (!stoppedOffers) return null
  return (
    <NotifyBar severity="warning">
      <span>Offers for this shift are stopped</span>
    </NotifyBar>
  )
}

ListingShiftOffersStoppedAlert.propTypes = {
  stoppedOffers: PropTypes.bool,
}

export default connect((state, props) => {
  const shift = state.listingShifts.entityDetail[props.shiftID] || {}
  const isSyftForce = getIsSyftForce(state.listings, props.listingID)
  return {
    stoppedOffers: areShiftOffersStopped(shift, isSyftForce),
  }
})(ListingShiftOffersStoppedAlert)
